export default __webpack_public_path__ + "static/media/MJME.5e43b6cf.png";